import { Button, Empty, Pagination, Skeleton, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import CustomBreadCrumb from '../../components/lib/CustomBreacCrumb';
import { axionsInstanceBaseApi } from '../../components/network';
import { render } from '@testing-library/react';


interface DataProps {
  list: any[],
  totalCount: number
}

const InitalData: DataProps = {
  list: [],
  totalCount: 0
}

const UserList = () => {

  const [data, setData] = useState(InitalData)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchUserList = async () => {

    const token = localStorage.getItem('imToken')

    const url = `/user/get_users`
    try {

      const { data } = await axionsInstanceBaseApi.post(url, { genders: [1], nomral: 1, pagination: { pageNumber: 1, showNumber: 10 } }, {
        headers: { 'Content-Type': 'application/json', 'Token': token },
      })
      setData({
        ...data,
        list: data?.data?.users,
        totalCount: data?.data?.total
      })
    } catch (e: any) {
      console.log('GET_USERSSS_ERRORR========', e.message)
    }
  }

  useEffect(() => {
    fetchUserList()
  }, [])


  const dataSource = data?.list || []

  const convertTimestampToDate = (timestamp: string) => {

    const timestampNumber = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;
    const date = new Date(timestampNumber);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}_${month}_${day}`;
  }

  const columns = [
    {
      title: '№',
      dataIndex: 'index',
      key: 'index',
      render: (text: any, record: any, index: number) => {
        return (<React.Fragment>{index + 1}</React.Fragment>)
      }
    },
    {
      title: 'userID',
      dataIndex: 'userID',
      key: 'userID',
    },
    {
      title: 'Nickname',
      dataIndex: 'nickname',
      key: 'nickname',
    },
    {
      title: 'faceURL',
      dataIndex: 'faceURL',
      key: 'faceURL',
      render: (faceUrl: string) => {
        return (<img className='h-11 w-11 object-cover rounded-md outline-none border-none bg-gray-200' alt='faceUrl' src={faceUrl ? faceUrl : '/defaultImage.png'} />)
      }
    },
    {
      title: 'createTime',
      dataIndex: 'createTime',
      key: 'createTime',
      render: (createTime: string) => {
        const formattedDate = convertTimestampToDate(createTime);
        return (
          <React.Fragment>
            {formattedDate}
          </React.Fragment>
        )
      }
    },
    {
      title: 'Үйлдэл',
      key: 'action',
      render: (item: any) => {

        return (
          <>
            <Space>
              <Button style={{ color: 'blue' }} type="primary" className='!text-white'>
                Хориглох
              </Button>

            </Space>
          </>
        )
      },
    },
  ];

  const onPageChange = (page: number) => {
    // setSearch({ page: page })
    // setPage(page)
    // navigate({ search: `?${QueryString.stringify({ ...params, page })}` })
  }

  const onShowSizeChange = (page: number) => {
    // setSearch({ page: page })
    // setPage(page)
    // navigate({ search: `?${QueryString.stringify({ ...params, page })}` })
  }
  const showTotal = (total: number, range: number[]) => {
    return (
      <>
        Нийт: <span>{total}</span>
      </>
    )
  }

  return (
    <div>
      <CustomBreadCrumb item={[{ name: 'Хянах самбар', link: '/dashboard' }, { name: 'Хэрэглэгчийн жагсаалт', link: '/chat/userList' }]} />
      <Table
        locale={{
          emptyText: loading ? <Skeleton active={true} /> : <Empty />,
        }}
        dataSource={dataSource}
        columns={columns}
        pagination={false} />
      <div className='flex justify-end my-6'>
        <Pagination
          pageSize={10}
          total={data?.totalCount}
          current={1}
          onChange={onPageChange}
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          showTotal={showTotal}
        />
      </div>
    </div>
  )
}

export default UserList